import React from 'react';

import cs from 'classnames';

import {useSetAcceptanceStatus} from 'app/acceptance/api';
import StateButton from 'app/general/widgets/StateButton';

import type {
  AcceptanceStatusSerializedType,
  BaseDocumentContentType,
} from 'sweet-types';

type Props = {
  acceptancestatus: AcceptanceStatusSerializedType;
  contentType: BaseDocumentContentType;
  documentId: number;
  targetStatus: boolean;
  icon: string;
  idleLabel: string;
  activeLabel: string;
  busyLabel: string;
  className?: string;
};

export const AcceptanceStatusButton = ({
  acceptancestatus,
  contentType,
  documentId,
  targetStatus,
  icon,
  idleLabel,
  activeLabel,
  busyLabel,
  className,
}: Props) => {
  const [setAcceptanceStatus] = useSetAcceptanceStatus();
  const isActive = acceptancestatus.status === targetStatus;

  return (
    <StateButton
      className={cs(className, {active: isActive})}
      disabled={isActive}
      busyText={<span className="d-none d-sm-inline">{busyLabel}</span>}
      onClick={() =>
        setAcceptanceStatus({
          id: acceptancestatus.id,
          document_id: documentId,
          content_type: contentType,
          status: targetStatus,
        }).unwrap()
      }
    >
      <i className={cs('fal mr-2', icon)} />
      {isActive ? activeLabel : idleLabel}
    </StateButton>
  );
};
